import { render, staticRenderFns } from "./BOpenDataHeader.vue?vue&type=template&id=2b22a06c&scoped=true"
import script from "./BOpenDataHeader.vue?vue&type=script&lang=js"
export * from "./BOpenDataHeader.vue?vue&type=script&lang=js"
import style0 from "./BOpenDataHeader.vue?vue&type=style&index=0&id=2b22a06c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b22a06c",
  null
  
)

export default component.exports